import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { VERSION } from '@ideapa/app-common';
import { LoginResponseDto } from '@ideapa/common-dto';
import { FormGroupState } from 'ngrx-forms';
import { AuthFacade } from '../../+state/auth.facade';
import { EmailOtpVerifyCodeFormValue } from '../../+state/auth.reducer';
import { AuthService } from '../../auth.service';

@Component({
  standalone: false,
  selector: 'ideapa-email-otp-verify',
  templateUrl: './email-otp-verify.container.html',
  styleUrls: ['./email-otp-verify.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailOtpVerifyContainer implements OnInit {
  verifyEmailOtpForm$ = this.authFacade.selectVerifyEmailOtpForm$;
  loginResponse: LoginResponseDto | null = null;
  constructor(
    @Inject(VERSION) public version: string,
    private authFacade: AuthFacade,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loginResponse = this.authService.getLoginResponse();
  }

  async onSubmit(form: FormGroupState<EmailOtpVerifyCodeFormValue>) {
    if (form.isValid) {
      if (this.loginResponse) {
        this.authFacade.verifyEmailOTP(
          form.controls.otpCode.value,
          this.loginResponse
        );
      } else {
        this.authFacade.missingLoginResponse();
      }
    }
  }
}
